import React from 'react';

import { ButtonContainer, ButtonText, ButtonImage, GlobalStyle } from './styles';

export default function GovButton({
  cod_parque_servico,
  marginBottom = false,
}: {
  cod_parque_servico: number;
  marginBottom?: boolean;
}) {
  const naoPodeUsarGov =
    !process.env.REACT_APP_URL_REDIRECT_GOV ||
    !process.env.REACT_APP_CLIENT_SECRET_GOV ||
    !process.env.REACT_APP_CLIENT_ID_GOV;

  return naoPodeUsarGov ? null : (
    <>
      <GlobalStyle />
      <ButtonContainer
        marginBottom={marginBottom}
        onClick={() => {
          const redirectUrl = `https://app.ilumina.maceio.al.gov.br/auth/login-cidadao/iframe-${cod_parque_servico}/`;

          window.open(
            `https://sso.acesso.gov.br/authorize?response_type=code&client_id=p-app.ilumina.maceio.al.gov.br&scope=openid+email+profile&redirect_uri=${redirectUrl}`,
            '_self',
          );
        }}
      >
        <ButtonText>Entrar com</ButtonText>
        <ButtonImage src="https://www.gov.br/++theme++padrao_govbr/img/govbr-colorido-b.png" alt="gov.br" />
      </ButtonContainer>
    </>
  );
}
